import React from 'react'
import Layout from '../component/Layout/Layout'

const PhonePePaymentFailed = () => {
  return (
    <Layout
    title="My Orders : Chaashni Couture"
    description="Chaashni Couture: Description"
  >
    <div className="site-content-wrap my-account">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1 className="sustom-heading-h1">Order<span> Status</span></h1>
            <h4 className='text-center text-danger'>Payment Failed!</h4>
          </div>
        </div>
      </div>
    </div>
  </Layout>
  )
}

export default PhonePePaymentFailed
